import React, { useRef, useState } from 'react';

interface DownloaderProps {
  children: (props: {
    isSubmitting: boolean;
    triggerDownload: (fileName: string, fetcher: () => Promise<Blob>) => Promise<void>;
  }) => React.ReactNode;
}

export const Downloader: React.FC<DownloaderProps> = ({ children }) => {
  const downloadRef = useRef<HTMLAnchorElement | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const triggerDownload = (fileName: string, fetcher: () => Promise<Blob>) => {
    setIsSubmitting(true);
    return fetcher()
      .then((r) => {
        downloadRef.current!.href = URL.createObjectURL(r);
        downloadRef.current!.download = fileName;
        downloadRef.current?.click();
      })
      .catch(console.error)
      .finally(() => setIsSubmitting(false));
  };

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid */}
      <a ref={downloadRef} hidden />
      {children({ isSubmitting, triggerDownload })}
    </>
  );
};
